<template>
  <div>
    <modal name="editCampo" height="auto" width="90%" :maxWidth="1200" :adaptive="true" :scrollable="true" :clickToClose="false" @before-open="onBeforeOpen">
      <CamposDisponiveis
          :campos="tipo.de"
          nome="camposDisponiveisDe"
          :onSelect="alterarCampoDe"
      />
      <CamposDisponiveis
          :campos="tipo.para"
          nome="camposDisponiveisPara"
          :onSelect="alterarCampoPara"
      />
      <CloseModal :close="tentarFechar"/>

      <div class="modalbox">
        <div class="modalbox-content">
          <nav class="breadcrumb-bar" aria-label="Localização atual">
            <span class="breadcrumb-item">
              <fa-icon icon="exchange-alt" /> {{ tipo.titulo }}
            </span>
            <fa-icon icon="chevron-right" class="breadcrumb-sep" />
            <span class="breadcrumb-item" :class="{ 'breadcrumb-item--ativo': vista === 'lista' }">
              <a v-if="vista !== 'lista'" href="#" @click.prevent="voltarLista">Mapeamentos</a>
              <span v-else>Mapeamentos</span>
            </span>
            <template v-if="vista !== 'lista'">
              <fa-icon icon="chevron-right" class="breadcrumb-sep" />
              <span class="breadcrumb-item breadcrumb-item--ativo">
                {{ vista === 'tipo' ? 'Tipo de mapeamento' : (campoEditandoRef && campoEditandoRef.regra ? badgeLabel(campoEditandoRef) : 'Campo simples') }}
              </span>
            </template>
          </nav>

          <div class="modal-header-info" v-if="vista === 'lista'">
            <div class="header-title">{{ tipo.titulo }}</div>
            <div class="header-desc">
              Chave: <code>{{ tipo.chave }}</code> · {{ campos.length }} mapeamento(s)
            </div>
          </div>

          <!-- VISTA: LISTA -->
          <template v-if="vista === 'lista'">
            <div v-if="campos.length === 0" class="empty-state">
              <div class="empty-icon"><fa-icon icon="cubes" /></div>
              <div class="empty-text">Nenhum mapeamento cadastrado</div>
              <div class="empty-desc">
                Mapeamentos transformam dados da Verso em campos do ERP.
                <br />Exemplo: <code>pedido.id</code> → <code>U_VS_PedidoEcommerce</code>
              </div>
              <div class="empty-exemplos">
                <div class="exemplo-card">
                  <fa-icon icon="exchange-alt" class="exemplo-ico" />
                  <strong>Campo simples</strong>
                  <span>Envia o valor da Verso direto para um campo do ERP</span>
                </div>
                <div class="exemplo-card">
                  <fa-icon icon="code-branch" class="exemplo-ico" />
                  <strong>Condicional</strong>
                  <span>Lógica E/OU + múltiplas saídas por regra</span>
                </div>
                <div class="exemplo-card">
                  <fa-icon icon="table" class="exemplo-ico" />
                  <strong>Mapeamento</strong>
                  <span>De-para entre valores (1 → "PF", 2 → "PJ")</span>
                </div>
              </div>
              <div v-if="tiposImportaveis.length > 0" class="empty-importar">
                <span class="importar-label">Ou copie os mapeamentos de outro tipo:</span>
                <div class="importar-controle">
                  <select v-model="tipoParaImportar" class="form-control form-control-sm importar-select">
                    <option value="">Selecione um tipo…</option>
                    <option v-for="t in tiposImportaveis" :key="t.chave" :value="t.chave">
                      {{ t.titulo }} ({{ t.qtd }} mapeamentos)
                    </option>
                  </select>
                  <CButton
                    color="primary"
                    variant="outline"
                    size="sm"
                    :disabled="!tipoParaImportar"
                    @click="importarDeOutroTipo"
                  >
                    <fa-icon icon="file-import" /> Importar
                  </CButton>
                </div>
              </div>
            </div>

            <div
              v-for="(campo, idx) in campos"
              :key="idx"
              class="lista-card"
              :class="{ 'lista-card--invalid': !isCampoValido(campo) }"
              @click="editandoNomeIdx === idx ? null : abrirEditor(idx)"
            >
              <span class="lista-ordem">#{{ idx + 1 }}</span>
              <span class="lista-tipo-badge" :class="badgeClass(campo)">
                <fa-icon :icon="badgeIcone(campo)" /> {{ badgeLabel(campo) }}
              </span>
              <template v-if="editandoNomeIdx === idx">
                <div class="lista-nome-edit" @click.stop>
                  <input
                    ref="inputNome"
                    type="text"
                    class="form-control form-control-sm"
                    v-model="nomeEditando"
                    :placeholder="resumoLinha(campo)"
                    @keyup.enter="salvarNome(idx)"
                    @keyup.esc="cancelarEdicaoNome"
                  />
                  <CButton color="link" size="sm" class="btn-icon" @click="restaurarNomePadrao" title="Voltar ao nome padrão" aria-label="Restaurar nome padrão">
                    <fa-icon icon="undo" />
                  </CButton>
                  <CButton color="link" size="sm" class="btn-icon" @click="salvarNome(idx)" title="Confirmar" aria-label="Confirmar nome">
                    <fa-icon icon="check" />
                  </CButton>
                  <CButton color="link" size="sm" class="btn-icon" @click="cancelarEdicaoNome" title="Cancelar" aria-label="Cancelar edição de nome">
                    <fa-icon icon="times" />
                  </CButton>
                </div>
              </template>
              <span v-else class="lista-resumo" :class="{ 'lista-resumo--custom': !!campo.nome }">
                {{ campo.nome || resumoLinha(campo) }}
              </span>
              <div v-if="editandoNomeIdx !== idx" class="lista-acoes" @click.stop>
                <CButton color="link" size="sm" class="btn-icon" @click="iniciarEdicaoNome(idx)" title="Renomear" aria-label="Renomear mapeamento">
                  <fa-icon icon="tag" />
                </CButton>
                <CButton color="link" size="sm" class="btn-icon" @click="abrirEditor(idx)" title="Editar" aria-label="Editar mapeamento">
                  <fa-icon icon="pencil-alt" />
                </CButton>
                <CButton color="link" size="sm" class="btn-icon" @click="duplicarCampo(idx)" title="Duplicar" aria-label="Duplicar mapeamento">
                  <fa-icon icon="copy" />
                </CButton>
                <CButton color="danger" variant="ghost" size="sm" class="btn-icon" @click="onRemoveCampo(idx)" title="Remover" aria-label="Remover mapeamento">
                  <fa-icon icon="trash-alt" />
                </CButton>
              </div>
            </div>

            <CButton color="primary" variant="outline" size="sm" class="btn-add-mapeamento btn-dashed" @click="abrirSeletor">
              <fa-icon icon="plus" /> Adicionar mapeamento
            </CButton>
          </template>

          <!-- VISTA: SELETOR DE TIPO -->
          <TipoRegraSelector
            v-else-if="vista === 'tipo'"
            @voltar="voltarLista"
            @selecionar="criarComTipo"
          />

          <!-- VISTA: EDITOR DE REGRA -->
          <template v-else-if="vista === 'editor' && campoEditandoRef">
            <div class="editor-header">
              <CButton color="link" size="sm" class="btn-voltar" @click="voltarLista">
                <fa-icon icon="arrow-left" /> Voltar para a lista
              </CButton>
              <div class="editor-titulo">
                {{ campoEditandoRef.regra ? badgeLabel(campoEditandoRef) : 'Campo simples' }}
              </div>
            </div>

            <div v-if="mostrarErros && errosResumo.length" class="erros-summary" role="alert">
              <div class="erros-summary-header">
                <fa-icon icon="exclamation-triangle" />
                <strong>{{ errosResumo.length }} problema(s) impedem o salvamento</strong>
              </div>
              <ul class="erros-lista">
                <li v-for="(e, i) in errosResumo" :key="i">
                  <strong>{{ e.titulo }}:</strong> {{ e.descricao }}
                </li>
              </ul>
            </div>

            <!-- Modo simples -->
            <div v-if="!campoEditandoRef.regra" class="editor-secao">
              <div class="secao-titulo">Origem</div>
              <div class="row form-group">
                <div class="col-md-12">
                  <label class="field-label">{{ campoDe(campoEditandoRef.de) }}</label>
                  <input
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': mostrarErros && (!campoEditandoRef.de || campoEditandoRef.de.trim().length === 0) }"
                      :aria-invalid="mostrarErros && (!campoEditandoRef.de || campoEditandoRef.de.trim().length === 0)"
                      type="text"
                      v-model="campoEditandoRef.de"
                  />
                  <div v-if="mostrarErros && (!campoEditandoRef.de || !campoEditandoRef.de.trim())" class="invalid-feedback d-block">
                    Campo de origem é obrigatório.
                  </div>
                  <CButton v-if="possuiCamposDe" color="primary" variant="ghost" size="sm" class="btn-selecionar" @click="openModalCamposDisponiveisDe(campoEditandoRef)">
                    Selecionar da lista
                  </CButton>
                </div>
              </div>
            </div>

            <!-- Modo regra -->
            <div v-else class="editor-secao">
              <RegraCampoEditor
                  :value="campoEditandoRef.regra"
                  :campos="camposParaRegra"
                  :operadores="operadores"
                  :modo-troca-tipo="false"
                  :para-value="campoEditandoRef.para || ''"
                  :possui-campos-para="possuiCamposPara"
                  :placeholder-para="campoPara(campoEditandoRef.para)"
                  :mostrar-erros="mostrarErros"
                  @input="atualizarRegra(campoEditandoRef, $event)"
                  @update:paraValue="campoEditandoRef.para = $event"
                  @selecionar-para="openModalCamposDisponiveisPara(campoEditandoRef)"
              />
            </div>

            <div v-if="!isCondicional(campoEditandoRef)" class="editor-secao">
              <div class="secao-titulo">Destino no ERP</div>
              <div class="row form-group">
                <div class="col-md-12">
                  <label class="field-label">{{ campoPara(campoEditandoRef.para) }}</label>
                  <input
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': mostrarErros && (!campoEditandoRef.para || campoEditandoRef.para.trim().length === 0) }"
                      :aria-invalid="mostrarErros && (!campoEditandoRef.para || campoEditandoRef.para.trim().length === 0)"
                      type="text"
                      v-model="campoEditandoRef.para"
                  />
                  <div v-if="mostrarErros && (!campoEditandoRef.para || !campoEditandoRef.para.trim())" class="invalid-feedback d-block">
                    Campo de destino é obrigatório.
                  </div>
                  <CButton v-if="possuiCamposPara" color="primary" variant="ghost" size="sm" class="btn-selecionar" @click="openModalCamposDisponiveisPara(campoEditandoRef)">
                    Selecionar da lista
                  </CButton>
                </div>
              </div>
            </div>

            <div class="editor-secao">
              <CButton color="link" size="sm" class="secao-toggle" @click="opcoesAbertas = !opcoesAbertas">
                <fa-icon :icon="opcoesAbertas ? 'chevron-down' : 'chevron-right'" />
                Opções avançadas (funções, formato, valor padrão, incluir se nulo)
              </CButton>
              <div v-if="opcoesAbertas">
                <div class="row form-group opcoes-row">
                  <div class="col-md-3">
                    <label class="field-label">
                      Valor padrão
                      <fa-icon
                        icon="info-circle"
                        class="info-icon"
                        title="Aplicado quando a regra retorna null, 0, false ou string vazia. Se você precisa enviar 0 ou false literais ao ERP, defina este campo como '0' ou 'false'."
                      />
                    </label>
                    <input class="form-control form-control-sm" type="text" v-model="campoEditandoRef.valor_padrao" />
                    <small class="text-muted field-hint">
                      Usado quando a regra retorna vazio. Para enviar <code>0</code>/<code>false</code> literal, preencha aqui.
                    </small>
                  </div>
                  <div class="col-md-3">
                    <label class="field-label">Formato</label>
                    <select v-model="campoEditandoRef.conversao" class="form-control form-control-sm">
                      <option v-for="(value, label) in formatos" :key="label" :value="value">{{ label }}</option>
                    </select>
                  </div>
                  <div v-if="validaFormato(campoEditandoRef)" class="col-md-3">
                    <label class="field-label">Inverter sinal</label>
                    <select v-model="campoEditandoRef.inverte_sinal" class="form-control form-control-sm">
                      <option value="1">Sim</option>
                      <option value="0">Não</option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label class="field-label">Incluir se nulo</label>
                    <select v-model="campoEditandoRef.incluir_se_nulo" class="form-control form-control-sm">
                      <option value="1">Sim</option>
                      <option value="0">Não</option>
                    </select>
                  </div>
                </div>
                <div v-if="!isCondicional(campoEditandoRef)" class="row form-group">
                  <div class="col-md-12">
                    <label class="field-label">Funções de formatação (aplicadas em ordem, antes do formato)</label>
                    <FuncoesPipeline v-model="campoEditandoRef.funcoes" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="modal-footer-bar">
        <CButton variant="outline" color="secondary" @click="close">Cancelar</CButton>
        <span v-if="vista === 'lista' && alteracoesPendentes" class="alteracoes-pendentes">
          <fa-icon icon="circle" /> Alterações não salvas
        </span>
        <div class="footer-spacer"></div>
        <CButton
          v-if="vista === 'editor'"
          color="primary"
          @click="trySalvarEditor"
          title="Confirma este mapeamento e volta para a lista (ainda não persiste no servidor)"
        >
          <fa-icon icon="check" /> Aplicar mapeamento
        </CButton>
        <CButton
          v-else-if="vista === 'lista'"
          color="success"
          :disabled="!camposValidos || !alteracoesPendentes"
          @click="handleSubmit"
          title="Persiste todos os mapeamentos no servidor"
        >
          <fa-icon icon="save" /> Salvar tudo
        </CButton>
      </div>
    </modal>
  </div>
</template>

<script>
import CloseModal from "../../../components/CloseModal";
import CamposDisponiveis from "./CamposDisponiveis";
import RegraCampoEditor, { novaRegra } from "./RegraCampoEditor";
import TipoRegraSelector from "./TipoRegraSelector";
import FuncoesPipeline from "./FuncoesPipeline";
import { isEmpty, cloneDeep } from "lodash";

const campoMapeado = (tipo) => ({
  'de': '',
  'para': '',
  'conversao': null,
  'funcoes': [],
  'inverte_sinal': 0,
  'incluir_se_nulo': 1,
  'valor_padrao': '',
  'ordem': 1,
  'regra': null,
  tipo
});

const TIPO_BADGES = {
  simples:      { label: 'Simples',      icone: 'exchange-alt', cls: 'badge--simples' },
  condicional:  { label: 'Condicional',  icone: 'code-branch',  cls: 'badge--condicional' },
  mapeamento:   { label: 'Mapeamento',   icone: 'table',        cls: 'badge--mapeamento' },
  concatenacao: { label: 'Concatenação', icone: 'link',         cls: 'badge--concatenacao' },
  coalesce:     { label: '1º disponível',icone: 'list-ol',      cls: 'badge--coalesce' },
};

export default {
  name: "Edit",
  components: {
    CamposDisponiveis,
    CloseModal,
    RegraCampoEditor,
    TipoRegraSelector,
    FuncoesPipeline,
  },
  props: [
    'close',
    'tipo',
    'campos',
    'formatos',
    'funcoesCatalogo',
    'operadores',
    'onSubmit',
    'todosCampos',
    'grupos',
  ],
  provide() {
    const self = this;
    // Getter reativo: o catálogo é carregado de forma assíncrona, então
    // expomos um acessor que lê a prop reativa no momento do uso (padrão
    // de provide/inject reativo do Vue 2), consumido por FuncoesPipeline.
    return {
      catalogoFuncoes: {
        get value() {
          return self.funcoesCatalogo || [];
        },
      },
    };
  },
  data() {
    return {
      vista: 'lista',
      indexEditando: null,
      campoEmEdicao: {},
      indiceCampoEmEdicao: null,
      opcoesAbertas: false,
      editandoNomeIdx: null,
      nomeEditando: '',
      mostrarErros: false,
      snapshotCampos: '[]',
      tipoParaImportar: '',
    };
  },
  watch: {
    'tipo.chave'() {
      // Sempre que mudar o tipo selecionado na tela principal, voltar para lista
      this.vista = 'lista';
      this.indexEditando = null;
      this.opcoesAbertas = false;
    },
  },
  computed: {
    campoEditandoRef() {
      if (this.indexEditando === null) return null;
      return this.campos[this.indexEditando];
    },
    camposValidos() {
      return this.campos.every((c) => this.isCampoValido(c));
    },
    alteracoesPendentes() {
      return JSON.stringify(this.campos || []) !== this.snapshotCampos;
    },
    tiposImportaveis() {
      if (!this.todosCampos || !this.grupos) return [];
      const result = [];
      for (const grupo of Object.values(this.grupos)) {
        for (const [chave, t] of Object.entries(grupo.tipos || {})) {
          if (chave === this.tipo.chave) continue;
          const arr = this.todosCampos[chave] || [];
          if (arr.length > 0) result.push({ chave, titulo: t.titulo, qtd: arr.length });
        }
      }
      return result.sort((a, b) => a.titulo.localeCompare(b.titulo));
    },
    errosResumo() {
      const campo = this.campoEditandoRef;
      if (!campo) return [];
      const erros = [];
      if (campo.regra) {
        if (campo.regra.tipo === 'condicional') {
          const casos = campo.regra.casos || [];
          if (casos.length === 0) {
            erros.push({ titulo: 'Sem regras', descricao: 'Adicione ao menos uma regra condicional.' });
          }
          casos.forEach((caso, ci) => {
            const saidas = Array.isArray(caso.entao) ? caso.entao : [];
            if (saidas.length > 0) {
              saidas.forEach((s, si) => {
                const para = s && s.para ? String(s.para).trim() : '';
                if (!para) erros.push({ titulo: `Regra ${ci + 1} → destino ${si + 1}`, descricao: 'Campo "Para" vazio.' });
                const e = s && s.expressao;
                const v = e && e.valor != null ? String(e.valor).trim() : '';
                const c = e && e.caminho != null ? String(e.caminho).trim() : '';
                if (!v && !c) erros.push({ titulo: `Regra ${ci + 1} → destino ${si + 1}`, descricao: 'Expressão "De" sem valor.' });
              });
            } else {
              const entao = caso.entao;
              const v = entao && entao.valor != null ? String(entao.valor).trim() : '';
              const c = entao && entao.caminho != null ? String(entao.caminho).trim() : '';
              if (v || c) {
                if (!campo.para || !campo.para.trim()) {
                  erros.push({ titulo: `Regra ${ci + 1}`, descricao: 'Campo "Para" vazio.' });
                }
              }
            }
          });
          const senao = campo.regra.senao;
          if (Array.isArray(senao) && senao.length > 0) {
            senao.forEach((s, si) => {
              const para = s && s.para ? String(s.para).trim() : '';
              if (!para) erros.push({ titulo: `Senão → destino ${si + 1}`, descricao: 'Campo "Para" vazio.' });
              const e = s && s.expressao;
              const v = e && e.valor != null ? String(e.valor).trim() : '';
              const c = e && e.caminho != null ? String(e.caminho).trim() : '';
              if (!v && !c) erros.push({ titulo: `Senão → destino ${si + 1}`, descricao: 'Expressão "De" sem valor.' });
            });
          }
        } else if (!campo.para || !campo.para.trim()) {
          erros.push({ titulo: 'Destino', descricao: 'Campo "Para" vazio.' });
        }
      } else {
        if (!campo.de || !campo.de.trim()) erros.push({ titulo: 'Origem', descricao: 'Campo "De" vazio.' });
        if (!campo.para || !campo.para.trim()) erros.push({ titulo: 'Destino', descricao: 'Campo "Para" vazio.' });
      }
      return erros;
    },
    possuiCamposDe() {
      return !isEmpty(this.tipo.de);
    },
    possuiCamposPara() {
      return !isEmpty(this.tipo.para);
    },
    camposParaRegra() {
      if (isEmpty(this.tipo.de)) return [];
      return Object.entries(this.tipo.de).map(([value, label]) => ({ value, label }));
    },
  },
  methods: {
    isCampoValido(campo) {
      if (!campo) return false;
      if (campo.regra) {
        if (campo.regra.tipo === 'condicional') {
          return this.isCondicionalValido(campo);
        }
        return campo.para && campo.para.trim().length > 0;
      }
      return campo.de && campo.de.trim().length > 0
          && campo.para && campo.para.trim().length > 0;
    },
    isCondicional(campo) {
      return campo && campo.regra && campo.regra.tipo === 'condicional';
    },
    isCondicionalValido(campo) {
      const hasRowPara = !!(campo.para && String(campo.para).trim().length);
      const expressaoTemValor = (e) => {
        if (!e || typeof e !== 'object') return false;
        const v = e.valor != null ? String(e.valor).trim() : '';
        const c = e.caminho != null ? String(e.caminho).trim() : '';
        return v.length > 0 || c.length > 0;
      };
      const isSaidaValida = (saida) => {
        if (Array.isArray(saida)) {
          return saida.length > 0 && saida.every((it) => {
            const para = it && it.para ? String(it.para).trim() : '';
            return para.length > 0 && expressaoTemValor(it && it.expressao);
          });
        }
        if (!expressaoTemValor(saida)) return true;
        return hasRowPara;
      };
      const casos = (campo.regra.casos || []);
      if (casos.length === 0) return false;
      const todosCasosValidos = casos.every((c) => isSaidaValida(c.entao));
      const senao = campo.regra.senao;
      const senaoValido = senao == null ? true : isSaidaValida(senao);
      return todosCasosValidos && senaoValido;
    },
    isRegraEmpty(regra) {
      if (!regra) return true;
      if (regra.tipo !== 'condicional') return false;
      const expressaoTemValor = (e) => {
        if (!e || typeof e !== 'object') return false;
        return (e.valor != null && String(e.valor).trim().length > 0)
          || (e.caminho != null && String(e.caminho).trim().length > 0);
      };
      const saidaTemConteudo = (saida) => {
        if (Array.isArray(saida)) {
          return saida.some((it) => (it && it.para && String(it.para).trim()) || expressaoTemValor(it && it.expressao));
        }
        return expressaoTemValor(saida);
      };
      const algumCampo = (regra.casos || []).some((c) =>
        ((c && c.condicao && c.condicao.grupos) || []).some((g) =>
          ((g && g.condicoes) || []).some((cd) => cd && cd.campo)
        )
      );
      const algumEntao = (regra.casos || []).some((c) => saidaTemConteudo(c.entao));
      const senaoCheio = saidaTemConteudo(regra.senao);
      return !(algumCampo || algumEntao || senaoCheio);
    },
    trySalvarEditor() {
      if (!this.isCampoValido(this.campoEditandoRef || {})) {
        this.mostrarErros = true;
        return;
      }
      this.mostrarErros = false;
      this.voltarLista();
    },
    onBeforeOpen() {
      // Garante estado limpo a cada abertura — sem isso, reabrir o modal
      // mantém `vista`/`indexEditando` da sessão anterior e a tela fica
      // travada em uma vista inválida.
      this.vista = 'lista';
      this.indexEditando = null;
      this.indiceCampoEmEdicao = null;
      this.opcoesAbertas = false;
      this.editandoNomeIdx = null;
      this.nomeEditando = '';
      this.mostrarErros = false;
      // $nextTick garante snapshot APÓS o pai propagar a prop `campos`
      // do tipo escolhido — evita falso positivo de "alterações não salvas".
      this.$nextTick(() => {
        this.snapshotCampos = JSON.stringify(this.campos || []);
      });
    },
    temAlteracoesPendentes() {
      return JSON.stringify(this.campos || []) !== this.snapshotCampos;
    },
    tentarFechar() {
      if (!this.temAlteracoesPendentes()) {
        this.close();
        return;
      }
      this.$swal({
        title: 'Descartar alterações?',
        text: 'Você possui mapeamentos não salvos. Se sair agora, eles serão perdidos.',
        showCancelButton: true,
        icon: 'warning',
        confirmButtonText: 'Descartar',
        cancelButtonText: 'Continuar editando',
      })
        .then((res) => {
          if (res.value) this.close();
        })
        .catch(() => {});
    },
    iniciarEdicaoNome(idx) {
      this.editandoNomeIdx = idx;
      this.nomeEditando = this.campos[idx].nome || '';
      this.$nextTick(() => {
        const input = this.$refs.inputNome;
        const el = Array.isArray(input) ? input[0] : input;
        if (el) el.focus();
      });
    },
    cancelarEdicaoNome() {
      this.editandoNomeIdx = null;
      this.nomeEditando = '';
    },
    restaurarNomePadrao() {
      this.nomeEditando = '';
    },
    salvarNome(idx) {
      const campo = this.campos[idx];
      const valor = (this.nomeEditando || '').trim();
      if (valor) {
        this.$set(campo, 'nome', valor);
      } else {
        this.$delete(campo, 'nome');
      }
      this.cancelarEdicaoNome();
    },
    validaFormato(campo) {
      return campo.conversao == 'int' || campo.conversao == 'float';
    },
    alterarCampoDe(novoValor) {
      const alvo = this.campos[this.indiceCampoEmEdicao];
      if (alvo) this.$set(alvo, 'de', novoValor);
    },
    alterarCampoPara(novoValor) {
      const alvo = this.campos[this.indiceCampoEmEdicao];
      if (alvo) this.$set(alvo, 'para', novoValor);
    },
    openModalCamposDisponiveisDe(campo) {
      // Guarda o índice no array em vez da referência — evita que mutações
      // tardias do modal vazem para o campo errado se o usuário navegar.
      this.indiceCampoEmEdicao = this.campos.indexOf(campo);
      this.$modal.show('camposDisponiveisDe');
    },
    openModalCamposDisponiveisPara(campo) {
      this.indiceCampoEmEdicao = this.campos.indexOf(campo);
      this.$modal.show('camposDisponiveisPara');
    },
    campoDe(nomeCampo) {
      return 'De: ' + (this.tipo.de && this.tipo.de[nomeCampo] ? this.tipo.de[nomeCampo] : 'Campo customizado');
    },
    campoPara(nomeCampo) {
      return 'Para: ' + (this.tipo.para && this.tipo.para[nomeCampo] ? this.tipo.para[nomeCampo] : 'Campo customizado');
    },
    badgeClass(campo) {
      const t = campo.regra ? campo.regra.tipo : 'simples';
      return (TIPO_BADGES[t] || TIPO_BADGES.simples).cls;
    },
    badgeIcone(campo) {
      const t = campo.regra ? campo.regra.tipo : 'simples';
      return (TIPO_BADGES[t] || TIPO_BADGES.simples).icone;
    },
    badgeLabel(campo) {
      const t = campo.regra ? campo.regra.tipo : 'simples';
      return (TIPO_BADGES[t] || TIPO_BADGES.simples).label;
    },
    resumoLinha(campo) {
      const para = campo.para || '?';
      if (!campo.regra) {
        const de = campo.de || '?';
        return `${de}  →  ${para}`;
      }
      switch (campo.regra.tipo) {
        case 'mapeamento': {
          const origem = campo.regra.campo || '?';
          const n = Object.keys(campo.regra.mapa || {}).length;
          return `${origem} (${n} tradução${n === 1 ? '' : 'ões'})  →  ${para}`;
        }
        case 'concatenacao': {
          const n = (campo.regra.partes || []).length;
          return `${n} parte${n === 1 ? '' : 's'} concatenada${n === 1 ? '' : 's'}  →  ${para}`;
        }
        case 'coalesce': {
          const n = (campo.regra.campos || []).length;
          return `${n} campo${n === 1 ? '' : 's'} (1º preenchido)  →  ${para}`;
        }
        case 'condicional': {
          const n = (campo.regra.casos || []).length;
          return `${n} regra${n === 1 ? '' : 's'} + fallback  →  ${para}`;
        }
        default:
          return `(regra)  →  ${para}`;
      }
    },
    abrirSeletor() {
      this.vista = 'tipo';
    },
    importarDeOutroTipo() {
      if (!this.tipoParaImportar) return;
      const fonte = (this.todosCampos && this.todosCampos[this.tipoParaImportar]) || [];
      if (fonte.length === 0) return;
      this.$swal({
        title: `Importar ${fonte.length} mapeamento(s)?`,
        text: 'Os mapeamentos serão copiados como ponto de partida — você ainda precisa salvar para persistir.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Importar',
        cancelButtonText: 'Cancelar',
      }).then((res) => {
        if (!res.value) return;
        const copia = cloneDeep(fonte);
        this.campos.splice(0, this.campos.length, ...copia);
        this.tipoParaImportar = '';
      });
    },
    criarComTipo(tipoEscolhido) {
      try {
        const novo = campoMapeado(this.tipo.chave);
        if (tipoEscolhido !== 'simples') {
          novo.regra = novaRegra(tipoEscolhido);
        }
        this.campos.push(novo);
        this.indexEditando = this.campos.length - 1;
        this.vista = 'editor';
        this.opcoesAbertas = false;
        this.mostrarErros = false;
      } catch (e) {
        // Mantém o usuário na vista 'tipo' com feedback explícito em vez de
        // entrar em 'editor' com campoEditandoRef indefinido (template quebra).
        this.$swal({
          title: 'Não foi possível criar este mapeamento',
          text: e && e.message ? e.message : 'Erro desconhecido.',
          icon: 'error',
        });
        this.vista = 'tipo';
      }
    },
    abrirEditor(idx) {
      const campo = this.campos[idx];
      // Registros antigos não possuem `funcoes`; garante a chave reativa
      // para que o v-model do pipeline funcione no Vue 2.
      if (campo && !Array.isArray(campo.funcoes)) {
        this.$set(campo, 'funcoes', []);
      }
      this.indexEditando = idx;
      this.vista = 'editor';
      this.opcoesAbertas = false;
      this.mostrarErros = false;
    },
    voltarLista() {
      // Se voltou de um editor sem nada preenchido, descarta o registro
      // recém-criado (inclusive quando o usuário escolheu um tipo de regra
      // mas não chegou a configurá-la).
      if (this.vista === 'editor' && this.indexEditando !== null) {
        const campo = this.campos[this.indexEditando];
        if (campo && !campo.de && !campo.para && this.isRegraEmpty(campo.regra)) {
          this.campos.splice(this.indexEditando, 1);
        }
      }
      this.indexEditando = null;
      this.vista = 'lista';
      this.mostrarErros = false;
    },
    atualizarRegra(campo, regra) {
      this.$set(campo, 'regra', regra);
      this.$set(campo, 'de', '');
    },
    duplicarCampo(index) {
      const original = this.campos[index];
      if (!original) return;
      const copia = cloneDeep(original);
      if (copia.nome) {
        copia.nome = `${copia.nome} (cópia)`;
      }
      this.campos.splice(index + 1, 0, copia);
    },
    onRemoveCampo(index) {
      this.$swal({
        title: 'Confirma remover este mapeamento?',
        text: 'Essa ação não poderá ser desfeita.',
        showCancelButton: true,
        icon: 'warning',
        confirmButtonText: 'Remover',
        cancelButtonText: 'Cancelar',
      })
        .then((res) => {
          if (res.value) {
            this.campos.splice(index, 1);
            if (this.editandoNomeIdx === index) {
              this.cancelarEdicaoNome();
            }
          }
        })
        .catch(() => {});
    },
    handleSubmit() {
      this.onSubmit(this.campos, this.tipo.chave);
    },
  },
};
</script>

<style scoped>
.modal-header-info {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-default);
}
.header-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--primary);
}
.header-desc {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 4px;
}
.header-desc code {
  font-size: 11px;
  color: var(--text-strong);
  background: var(--border-soft);
  padding: 1px 5px;
  border-radius: 3px;
}

/* Empty state */
.empty-state { text-align: center; padding: 40px 20px; }
.empty-icon {
  width: 56px; height: 56px; border-radius: 14px;
  background: var(--primary-hover-bg); color: var(--primary);
  font-size: 22px;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 12px;
}
.empty-text { font-weight: 600; font-size: 15px; color: var(--text-darkest); }
.empty-desc {
  font-size: 13px;
  color: var(--text-muted);
  margin-top: 4px;
  line-height: 1.5;
}
.empty-desc code {
  background: var(--bg-subtle);
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: var(--text-strong);
}
.empty-exemplos {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  max-width: 600px;
  margin: 18px auto 0;
}
.exemplo-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 10px;
  border: 1px solid var(--border-default);
  border-radius: 8px;
  background: var(--bg-subtle);
  text-align: left;
  font-size: 11px;
  color: var(--text-muted);
}
.exemplo-card strong { color: var(--text-darkest); font-size: 12px; }
.exemplo-ico { color: var(--primary); margin-bottom: 4px; }
.empty-importar {
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px dashed var(--border-default);
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
.importar-label {
  display: block;
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 8px;
}
.importar-controle {
  display: flex;
  gap: 8px;
  align-items: center;
}
.importar-select { flex: 1; }
@media (max-width: 767.98px) {
  .empty-exemplos { grid-template-columns: 1fr; }
  .importar-controle { flex-direction: column; align-items: stretch; }
}

/* Lista de cards */
.lista-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  margin-bottom: 6px;
  border: 1px solid var(--border-medium);
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s;
}
.lista-card:hover {
  border-color: var(--primary);
  background: #fafbff;
}
.lista-card--invalid {
  border-color: #fda29b;
  background: var(--danger-bg);
}
.lista-ordem {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  background: var(--border-soft);
  padding: 2px 7px;
  border-radius: 4px;
  flex-shrink: 0;
}
.lista-tipo-badge {
  font-size: 11px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 12px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.badge--simples      { background: #eef2ff; color: #4338ca; }
.badge--condicional  { background: #fef3c7; color: #b45309; }
.badge--mapeamento   { background: #dcfce7; color: #15803d; }
.badge--concatenacao { background: #e0f2fe; color: #0369a1; }
.badge--coalesce     { background: #fce7f3; color: #be185d; }
.lista-resumo {
  flex: 1;
  font-size: 13px;
  color: var(--text-strong);
  font-family: 'Menlo', 'Consolas', monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lista-resumo--custom {
  font-family: inherit;
  color: #1f2937;
  font-weight: 500;
}
.lista-nome-edit {
  flex: 1;
  display: flex;
  gap: 4px;
  align-items: center;
}
.lista-nome-edit .form-control {
  flex: 1;
  min-width: 0;
}
.lista-acoes {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}
.btn-icon {
  padding: 0.125rem 0.4rem;
  line-height: 1;
}
.btn-dashed {
  border-style: dashed;
}
.btn-add-mapeamento {
  width: 100%;
  font-size: 13px;
  font-weight: 500;
  padding: 12px;
  margin-top: 8px;
}

/* Editor */
.editor-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border-default);
}
.btn-voltar {
  font-size: 13px;
}
.editor-titulo {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-darkest);
}
.editor-secao {
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border-soft);
}
.editor-secao:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.secao-titulo {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 8px;
}
.secao-toggle {
  font-size: 12px;
  font-weight: 500;
  padding-left: 0;
  padding-right: 0;
}
.secao-toggle ::v-deep .fa-icon,
.secao-toggle ::v-deep svg { margin-right: 6px; }
.opcoes-row { margin-top: 10px; }

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}
.btn-selecionar {
  font-size: 11px;
  margin-top: 4px;
}

/* Modal footer */
.modal-footer-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid var(--border-default);
  position: sticky;
  bottom: 0;
  background: #fff;
  z-index: 5;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.04);
}
.footer-spacer { flex: 1; }
.breadcrumb-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 12px;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border-default);
  background: var(--bg-subtle);
}
.breadcrumb-item { display: inline-flex; align-items: center; gap: 6px; }
.breadcrumb-item a {
  color: var(--primary);
  text-decoration: none;
}
.breadcrumb-item a:hover { text-decoration: underline; }
.breadcrumb-item--ativo { color: var(--text-darkest); font-weight: 500; }
.breadcrumb-sep { color: var(--text-subtle); font-size: 9px; }

.info-icon {
  color: var(--text-subtle);
  font-size: 10px;
  margin-left: 4px;
  cursor: help;
}
.info-icon:hover { color: var(--primary); }
.field-hint {
  display: block;
  font-size: 10px;
  color: var(--text-muted);
  margin-top: 3px;
  line-height: 1.4;
}
.field-hint code {
  background: var(--bg-subtle);
  padding: 0 4px;
  border-radius: 3px;
  font-size: 10px;
  color: var(--text-strong);
}

.alteracoes-pendentes {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #b45309;
  font-weight: 500;
}
.alteracoes-pendentes ::v-deep svg { font-size: 8px; }

.erros-summary {
  background: var(--danger-bg);
  border: 1px solid #fda29b;
  border-left: 4px solid var(--danger);
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 16px;
}
.erros-summary-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--danger);
  margin-bottom: 6px;
  font-size: 13px;
}
.erros-lista {
  margin: 0;
  padding-left: 22px;
  font-size: 12px;
  color: var(--text-strong);
}
.erros-lista li { line-height: 1.5; }
</style>
